function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/splitoperation
 */
import Operation from './operation';
import MergeOperation from './mergeoperation';
import Position from '../position';
import Range from '../range';
import { _insert, _move } from './utils';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Operation to split {@link module:engine/model/element~Element an element} at given
 * {@link module:engine/model/operation/splitoperation~SplitOperation#splitPosition split position} into two elements,
 * both containing a part of the element's original content.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var SplitOperation = /*#__PURE__*/function (_Operation) {
  _inherits(SplitOperation, _Operation);

  var _super = _createSuper(SplitOperation);

  /**
   * Creates a split operation.
   *
   * @param {module:engine/model/position~Position} splitPosition Position at which an element should be split.
   * @param {Number} howMany Total offset size of elements that are in the split element after `position`.
   * @param {module:engine/model/position~Position} insertionPosition Position at which the clone of split element
   * (or element from graveyard) will be inserted.
   * @param {module:engine/model/position~Position|null} graveyardPosition Position in the graveyard root before the element which
   * should be used as a parent of the nodes after `position`. If it is not set, a copy of the the `position` parent will be used.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function SplitOperation(splitPosition, howMany, insertionPosition, graveyardPosition, baseVersion) {
    var _this;

    _classCallCheck(this, SplitOperation);

    _this = _super.call(this, baseVersion);
    /**
     * Position at which an element should be split.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/splitoperation~SplitOperation#splitPosition
     */

    _this.splitPosition = splitPosition.clone(); // Keep position sticking to the next node. This way any new content added at the place where the element is split
    // will be left in the original element.

    _this.splitPosition.stickiness = 'toNext';
    /**
     * Total offset size of elements that are in the split element after `position`.
     *
     * @member {Number} module:engine/model/operation/splitoperation~SplitOperation#howMany
     */

    _this.howMany = howMany;
    /**
     * Position at which the clone of split element (or element from graveyard) will be inserted.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/splitoperation~SplitOperation#insertionPosition
     */

    _this.insertionPosition = insertionPosition;
    /**
     * Position in the graveyard root before the element which should be used as a parent of the nodes after `position`.
     * If it is not set, a copy of the the `position` parent will be used.
     *
     * The default behavior is to clone the split element. Element from graveyard is used during undo.
     *
     * @member {module:engine/model/position~Position|null} #graveyardPosition
     */

    _this.graveyardPosition = graveyardPosition ? graveyardPosition.clone() : null;

    if (_this.graveyardPosition) {
      _this.graveyardPosition.stickiness = 'toNext';
    }

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SplitOperation, [{
    key: "type",
    get: function get() {
      return 'split';
    }
    /**
     * Position inside the new clone of a split element.
     *
     * This is a position where nodes that are after the split position will be moved to.
     *
     * @readonly
     * @type {module:engine/model/position~Position}
     */

  }, {
    key: "moveTargetPosition",
    get: function get() {
      var path = this.insertionPosition.path.slice();
      path.push(0);
      return new Position(this.insertionPosition.root, path);
    }
    /**
     * Artificial range that contains all the nodes from the split element that will be moved to the new element.
     * The range starts at {@link ~#splitPosition} and ends in the same parent, at `POSITIVE_INFINITY` offset.
     *
     * @readonly
     * @type {module:engine/model/range~Range}
     */

  }, {
    key: "movedRange",
    get: function get() {
      var end = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
      return new Range(this.splitPosition, end);
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/splitoperation~SplitOperation} Clone of this operation.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/mergeoperation~MergeOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      var graveyard = this.splitPosition.root.document.graveyard;
      var graveyardPosition = new Position(graveyard, [0]);
      return new MergeOperation(this.moveTargetPosition, this.howMany, this.splitPosition, graveyardPosition, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      var element = this.splitPosition.parent;
      var offset = this.splitPosition.offset; // Validate whether split operation has correct parameters.

      if (!element || element.maxOffset < offset) {
        /**
         * Split position is invalid.
         *
         * @error split-operation-position-invalid
         */
        throw new CKEditorError('split-operation-position-invalid', this);
      } else if (!element.parent) {
        /**
         * Cannot split root element.
         *
         * @error split-operation-split-in-root
         */
        throw new CKEditorError('split-operation-split-in-root', this);
      } else if (this.howMany != element.maxOffset - this.splitPosition.offset) {
        /**
         * Split operation specifies wrong number of nodes to move.
         *
         * @error split-operation-how-many-invalid
         */
        throw new CKEditorError('split-operation-how-many-invalid', this);
      } else if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) {
        /**
         * Graveyard position invalid.
         *
         * @error split-operation-graveyard-position-invalid
         */
        throw new CKEditorError('split-operation-graveyard-position-invalid', this);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      var splitElement = this.splitPosition.parent;

      if (this.graveyardPosition) {
        _move(Range._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
      } else {
        var newElement = splitElement._clone();

        _insert(this.insertionPosition, newElement);
      }

      var sourceRange = new Range(Position._createAt(splitElement, this.splitPosition.offset), Position._createAt(splitElement, splitElement.maxOffset));

      _move(sourceRange, this.moveTargetPosition);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(SplitOperation.prototype), "toJSON", this).call(this);

      json.splitPosition = this.splitPosition.toJSON();
      json.insertionPosition = this.insertionPosition.toJSON();

      if (this.graveyardPosition) {
        json.graveyardPosition = this.graveyardPosition.toJSON();
      }

      return json;
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "className",
    get: function get() {
      return 'SplitOperation';
    }
    /**
     * Helper function that returns a default insertion position basing on given `splitPosition`. The default insertion
     * position is after the split element.
     *
     * @param {module:engine/model/position~Position} splitPosition
     * @returns {module:engine/model/position~Position}
     */

  }, {
    key: "getInsertionPosition",
    value: function getInsertionPosition(splitPosition) {
      var path = splitPosition.path.slice(0, -1);
      path[path.length - 1]++;
      return new Position(splitPosition.root, path, 'toPrevious');
    }
    /**
     * Creates `SplitOperation` object from deserilized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/splitoperation~SplitOperation}
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      var splitPosition = Position.fromJSON(json.splitPosition, document);
      var insertionPosition = Position.fromJSON(json.insertionPosition, document);
      var graveyardPosition = json.graveyardPosition ? Position.fromJSON(json.graveyardPosition, document) : null;
      return new this(splitPosition, json.howMany, insertionPosition, graveyardPosition, json.baseVersion);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `SplitOperation( ${ this.baseVersion } ): ${ this.splitPosition } ` +
    // @if CK_DEBUG_ENGINE //		`( ${ this.howMany } ) -> ${ this.insertionPosition }` +
    // @if CK_DEBUG_ENGINE //		`${ this.graveyardPosition ? ' with ' + this.graveyardPosition : '' }`;
    // @if CK_DEBUG_ENGINE // }

  }]);

  return SplitOperation;
}(Operation);

export { SplitOperation as default };